import React from 'react';
import { useTheme, createUseStyles } from 'react-jss';

import Loading from '@components/Base/Loading';

const useStyles = createUseStyles(({
  rem,
}) => ({
  customLoading: {
    position: 'fixed',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 9999,
    backgroundColor: 'rgba(87, 188, 249, 1)',
  },
}), {
  name: 'PreLoading'
})

const PreLoading = () => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <div className={classes.customLoading}>
      <Loading size={2} />
    </div>
  )
};

export default PreLoading;
